// daySchedule.js — la parrilla del día entera.
//
// 🔴 **La fuente ya NO es WordPress** (26.08.26): sale del servidor de la radio,
// `listen.astra.fm/programas.json`. Ver `services/programmes.js`.
//
// Lo que gana la parrilla con el cambio:
//
//   · **La columna de residente deja de ir vacía.** WordPress no tenía ese
//     campo y aquí se dejaba en blanco a propósito; el contrato del servidor lo
//     trae como `agente.nombre`.
//   · **Desaparece el hueco de la parrilla.** Los nueve programas cubren las 24
//     horas seguidas, así que ya no hay franjas sin programa —el hueco entre las
//     18 y las 20 que se veía era de los datos de WordPress, no del código.
//   · **Desaparece el desenrollado de la medianoche.** El contrato entrega
//     Nocturna como `[22, 24]`, no `[22, 0]`, así que el rango ya es creciente.
//   · **Desaparece el índice por estación**, que era la trampa de AGENTS.md.
import { getTodayProgrammes } from "@/services/programmes";
import { getRadioCurrentTime } from "@/utils/radioTime";

/**
 * La parrilla del día, ordenada y con el programa en antena marcado.
 * @returns {Promise<Array>} [{ name, range, start, end, startMin, endMin,
 *   genre, resident, image, live }]
 */
export async function getTodayShows() {
  return getTodayProgrammes();
}

/** El minuto del día en la zona de la radio. Lo pide la aguja de la regla. */
export function getRadioNowMinutes() {
  return Math.round(getRadioCurrentTime() * 60);
}
